(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      input: '[data-variant-id-input]',
      msgWrapper: '[data-error-msg]',
      msgText: '[data-error-msg-text]'
    };

    error = false;

    async render() {        
      this._enableInput();
      this.cartSection = document.querySelector('main-cart');
      this.isProductPage = this.getAttribute('page-type') === 'product';
      if (this.hasAttribute('cart-popup')) {
        this.$form.addEventListener('submit', this._handleSubmit.bind(this));
      }
    };

    _enableInput() {
      this.$input.disabled = false;
    }
    
    _handleSubmit(e) {
      e.preventDefault();
      this.formData = new FormData(e.target);
      this._addToCartRequest();
    };

    _addToCartRequest() {
      this._setLoading(true);
        if (this.error) {
            this.$msgWrapper.toggleAttribute('hidden', true);
        }
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            "Accept": "application/javascript",
            "X-Requested-With":"XMLHttpRequest"
        },
        body: this.formData
      })
      .then(res => {
        return res.json();
      })
      .then((res) => {
        if (res.status) {
            this.$msgText.innerText = res.message;
            this.$msgWrapper.toggleAttribute('hidden', false);
            this._setLoading(false);
            this.error = true;
            return
        }
        this.error = false;
        this.trigger('updateCart', {
          callback: () => {
            this._setLoading(false);
            if(this.cartSection) {
              this.cartSection.update();
            } else {
              this.trigger('openPopup', { target: 'CART' });
            }
          }
        })
      })
      .catch(error => {
        this._setLoading(false);
        console.log(error);
      });
    };
    
    _setLoading(status) {
      status ? (
        this.$addButton.setAttribute('loading', ''),
        this.$buyButton?.setAttribute('disabled', '')
      ) : (
        this.$addButton.removeAttribute('loading'),
        this.$buyButton?.removeAttribute('disabled')
      );
    };
  });
})();